module.exports = __webpack_public_path__ + "static/media/back_arrow_icon.af4d3e88.svg";